<template>
  <div>
    <div class="darkbg" v-if="darkBg"></div>
    <div :class="(customerClass ? 'block alertdialog ' + customerClass : 'block alertdialog')">
      <div class="content">
          <div class="modal__header">
            <h2 id="tic-title">Trip Information Check</h2>
          </div>
          <section class="notice">
            <p>
              Please also ensure that the <b class="accent">traveler’s full name, date of birth, gender, and other passport information match exactly as shown on the passport</b> to be used for this trip.
              <br />
              TripToGo is not liable for any costs resulting from mistakes.
            </p>
          </section>
          <section class="block noborder">
            <div class="block__title">
              <span class="icon"><img src="/images/icon_seform_green.png" /></span>
              <span>Tour Details</span>
            </div>
            <div class="kv rowTour">
                <div class="k">Tour Name:</div>
                <div class="v">{{ odata?.tripname??'' }}</div>
            </div>
            <div class="grid two-col">
              <div class="kv">
                <div class="k">Tour starts:</div>
                <div class="v">{{ odata?formatDateLocal(odata.depart_date):'' }}</div>
              </div>
              <div class="kv">
                <div class="k">Tour Ends:</div>
                <div class="v">{{  odata?formatDateLocal(new Date(odata.depart_date+'T00:00:01').nextDate(odata.alldays.length-1).getFullstring()):'' }}</div>
              </div>
              <div class="kv">
                <div class="k">Tour Duration:</div>
                <div class="v">{{ odata?.duration??'' }}</div>
              </div>
              <div class="kv"></div>
            </div>
          </section>
          <!-- Flights Details -->
          <section class="block" v-if="(odata?.flightSummary?.length || 0) > 1">
            <div class="block__title">
              <span class="icon"><img src="/images/Airport_green.png" /></span>
              <span>Flights Details</span>
            </div>
            <div class="grid two-col mborder">
              <div class="kv">
                <div class="k">Departing City:</div>
                <div class="v">{{odata.flightSummary[0].depart?.city??getDepartCity(0)}} 
                  {{(odata.flightSummary[0].depart?.airport??'')!=''?' ( '+odata.flightSummary[0].depart?.airport+' ) ':''}} </div>                            
              </div>
              <div class="kv">
                <div class="k">Departing Date:</div>
                <div class="v">{{ formatDateLocal(odata.flightSummary[0].depart?.at??odata.flightSummary[0].depart_date) }}</div>
              </div>
              <div class="kv">
                <div class="k">Returning City:</div>
                <div class="v">
                  {{odata.flightSummary[1].arrival?.city??getDepartCity(1)}} 
                  {{(odata.flightSummary[1].arrival?.airport??'')!=''?' ( '+odata.flightSummary[1].arrival?.airport+' ) ':''}} </div>                
              </div>
              <div class="kv">
                <div class="k">Returning Date:</div>
                <div class="v">{{formatDateLocal(odata.flightSummary[1].depart?.at??odata.flightSummary[1].depart_date)}}</div>
              </div>
            </div>
          </section>
          <!-- Traveler Passport Info -->
          <section class="block">
            <div class="block__title block__title--with-btn">
              <div class="block-row">
                <span class="icon"><img src="/images/icon_user_green.png"></span>
                <span>Traveler Passport Info</span>
              </div>
              <button class="btn btn--ghost" @click="close(2)">Edit</button>
            </div>
            
            <div class="cards">
              <template v-for="(room, ridx) in roomlist" :key="`room-${ridx}`">
                <article class="card" v-for="(pax, pidx) in room.Adultslist" :key="`adult-${ridx}-${pidx}`">
                  <div class="grid two-col">
                    <div class="kv">
                      <div class="vk">{{ getName(pax) }}</div>
                    </div>
                  </div>
                  <div class="grid two-col mborder">
                    <div class="kv">
                      <div class="k">Date of Birth:</div>
                      <div class="v">{{formatDateLocal(pax.Birthday)}}</div>
                    </div>
                    <div class="kv">
                      <div class="k">Nationality:</div>
                      <div class="v">{{getNationality(pax)}}</div>
                    </div>
                    <div class="kv">
                      <div class="k">Gender:</div>
                      <div class="v">{{ getGender(pax) }}</div>
                    </div>
                    <div class="kv">
                      <div class="k">Passport Number:</div>
                      <div class="v">{{ pax.PassportNo }}</div>
                    </div>
                    <div class="kv">
                    </div>
                    <div class="kv">
                      <div class="k">Expiration Date:</div>
                      <div class="v">{{ formatDateLocal(pax.Expireddate) }}</div>
                    </div>
                  </div>
                </article>
                <template v-if="room.Childlist ?? false">
                  <article class="card" v-for="(pax, pidx) in room.Childlist" :key="`child-${ridx}-${pidx}`">
                    <div class="grid two-col">
                      <div class="kv">
                        <div class="vk">{{ getName(pax) }}</div>
                      </div>
                    </div>
                    <div class="grid two-col mborder">
                      <div class="kv">
                      <div class="k">Date of Birth:</div>
                      <div class="v">{{formatDateLocal(pax.Birthday)}}</div>
                    </div>
                    <div class="kv">
                      <div class="k">Nationality:</div>
                      <div class="v">{{getNationality(pax)}}</div>
                    </div>
                    <div class="kv">
                      <div class="k">Gender:</div>
                      <div class="v">{{ getGender(pax) }}</div>
                    </div>
                    <div class="kv">
                      <div class="k">Passport Number:</div>
                      <div class="v">{{ pax.PassportNo }}</div>
                    </div>
                    <div class="kv">
                    </div>
                    <div class="kv">
                      <div class="k">Expiration Date:</div>
                      <div class="v">{{ formatDateLocal(pax.Expireddate) }}</div>
                    </div>
                    </div>
                  </article>    
                </template>
              </template>
            </div>

          </section>
      </div>
      <!-- Footer -->
      <footer class="modal__footer">
        <button class="btn btn--ghost" @click="close(0)">Back</button>
        <button class="btn btn--primary" @click="close(1)">Confirm &amp; Continue</button>
      </footer>
    </div>
  </div>
  <!-- -->
</template>
<script>
import '@/assets/main.css'
import { useI18n } from 'vue-i18n';
import Request from '@/services/Request'
import { formatDateLocal,formatName } from '@/utils/tool.js'

export default {
  emits: ['reviewCloseWin'],
  components: {},
  props: {
    roomlist: {
      type: Array,
      default: () => [],
    },
    odata: {
      type: Object,
      default: () => ({}),
    },
    customerClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formatDateLocal,
      formatName,
      darkBg:true,
      countries:[],
      itinerary: {},
    }
  },
  setup() {
    const { t } = useI18n();    
    return {
      t,
    };
  },
  created() { },    
  mounted() {
    this.initCountry()    
  },
  methods: {
    close(t=0) {
      let param = {type:t};
      this.$emit('reviewCloseWin', param);
    },
    initCountry(){
        new Request().webPost(
          {},
          (res) => {
            this.countries = res.success ? res.data : []
          },
          'product/product_trip/getCountries&getProvince=1',
          () => {},
          3000,
          3
        )
    },
    getName(item){
      return this.formatName(item.firstname, item.middlename, item.lastname)
    },
    getNationality(item){
      let curCountry = this.countries.find(
        (country) => country.country_id === item.Nationality
      )
      return curCountry?.name || ''
    },
    getGender(item){
      let val = item.Gender
      if (val == 1) return 'Male'
      else if (val == 2) return 'Female'
      else if (val == 0) return 'Unspecified'
      else if (val == 8) return 'Undisclosed'
    },
    getDepartCity(t=0){
      if (!this.odata.flightOffer?.info) return ''
      this.itinerary = this.odata.flightOffer.info.itineraries
      let item = this.itinerary[t]
      let res = item.depart?.city??item.depart_city
      if(item.depart?.airport??false)
      {
        res = ' ( '+item.depart?.airport+' ) '
      }
      if(t>0){
        res = item.depart?.city??item.arrival_city
        if(item.arrival?.airport??false)
        {
          res = ' ( '+item.arrival?.airport+' ) '
        }
      }
      return res
    }
  }
}
</script>



<style lang="scss" scoped>
/* ===== 背景遮罩（与 darkBg 配合） ===== */
.darkbg{
  position: fixed; inset: 0;
  background: rgba(17,24,39,.55);
  /* The mobile booking footer is fixed at z-index: 1200. Keep the review
     takeover above it so page actions cannot remain visible or clickable. */
  z-index: 1300;
}
/* ===== 弹窗容器 ===== */
.alertdialog{
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: min(860px, 92vw);
  max-height: calc(100vh - 48px);
  background: #fff;
  color: #111827;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
  padding: 18px 32px 16px;
  text-align: left; 
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 1301;
  
  /* 让内容左对齐，更接近设计稿 */
  /* 顶部右上角关闭图片的行 */
  > div[style*="text-align:right"]{ margin-bottom: 2px; }
  /* 你原有的图片行，设计图中不显示，缩到零不占位 */
  .row.childcenter{ padding: 0; margin: 0; }
  .picture{ width:0; height:0; overflow:hidden; }
  /* ===== Header ===== */
  .modal__header{
    display:flex; align-items:center; justify-content:space-between;
    margin-bottom: 6px;
  }
  .modal__header h2{
    font-size: 18px; font-weight: 700; color:#111827;
  }
  .icon-btn{
    border: none; background: transparent; color:#6b7280; cursor:pointer; padding:6px; border-radius:8px;
  }
  .icon-btn:hover{ background:#f3f4f6; color:#111827; }
  /* ===== 提示块 ===== */
  .notice{
    background:#f9fafb; border-radius:10px;
    padding:12px 14px; margin-bottom:14px; color:#374151; line-height:1.45;
    p{ margin:0; }
    .accent{ color:#e11d48; }
  }
  /* ===== 区块标题与分割 ===== */
  .block{
    border-top:1px solid #E5E7EB; 
    padding-top:14px; 
    margin-top:6px;
    border-radius: 0px;
  }
  .noborder{
    border-top:0px;
  }
  .block__title{
    display:flex; 
    align-items: flex-start; 
    gap:8px; 
    font-weight:700; 
    margin-bottom:10px;
    color:#4F6F52;
        
    .icon{ 
      font-size:18px; 
      img{
        width:20px;
      }
    }
    .block-row{
      display:flex; 
      align-items: flex-start; 
      gap:8px; 

      .icon{ 
        font-size:18px; 
        img{
          width:20px;
        }
      }
    }
  }
  .block__title--with-btn{
    display:flex; align-items:center; justify-content:space-between;
  }
  /* ===== 两列网格 & 键值行 ===== */
  .grid.two-col{
    display:grid; gap:10px 18px;
    grid-template-columns: 1fr 1fr;
  }
  .kv{ 
    display:flex; gap:8px; min-width: 0; 
   .k{ min-width:110px; color:#6b7280; flex: 0 0 auto; }
   .v{ color:#111827; word-break: break-word; }
   .vk{
     margin:10px 0px;
     font-weight: 600;
   }
  }
  .rowTour{
    margin:14px 0px;
  }
  /* ===== 卡片列表（旅客信息） ===== */
  .cards{ display:grid; gap:12px; }
  .card{
    border:1px solid #E5E7EB; border-radius:10px; padding:12px; background:#fff;
  }
  .card .row{ display:flex; justify-content:space-between; margin-bottom:6px; }
  /* ===== 按钮 ===== */
  .btn{
    appearance:none; border:none; border-radius:8px; padding:10px 14px; cursor:pointer;
    font-weight:600; font-size:14px; border-radius: 8px;
    border: 1px solid var(--text-normal-text, #333);
    background: #FFF;
  }
  .btn--primary{ border-radius: 8px;background: #00F1BD;border: 0px solid var(--text-normal-text, #333);}
  .btn--primary:hover{ filter:brightness(.95); }
  .btn--ghost{ color:#374151; }
  .btn--ghost:hover{ background:#e5e7eb; }
  .block__title--with-btn .btn--ghost{ padding:6px 10px; font-weight:600; }
  /* ===== 底部粘性操作栏 ===== */
  .modal__footer{
    display:flex; justify-content: space-between; gap:10px; margin-top:16px;
    position: relative; background: #fff; padding-top:10px;
    z-index: 2;
    flex-shrink: 0;
  }
  /* ===== 字体回退 ===== */
  *, .content{
    font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif;
    font-size: 14px;
    line-height: 1.6;
    scrollbar-width: none; /* Firefox */
  }
  .content{
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    flex: 1 1 auto;
  }
  /* WebKit 滚动条隐藏 */
  *::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
/* ===== 响应式：与设计稿一致在窄屏改为单列 ===== */
@media (max-width: 750px){
  .alertdialog{
    width: 92vw; padding: 16px;
    top: calc((100dvh - var(--mobile-nav-height, 0px)) / 2);
    max-height: calc(100dvh - 112px - var(--mobile-nav-height, 0px));
    .grid.two-col{ grid-template-columns: 1fr; }
    .kv .k{ min-width: 100px; }
    .content{
      padding-bottom: 0;
    }
    .modal__footer{
        position: relative;
        margin-top: 12px;
        padding-top: 10px;
        padding-bottom: max(8px, env(safe-area-inset-bottom));
        background: #fff;
        border-top: 1px solid #E5E7EB;
        flex-wrap: wrap;
        flex-direction: column;
      } 
  }  
  .alertdialog .grid.mborder {
    .kv:nth-child(1) {order: 1; }
    .kv:nth-child(2) { order: 3; }
    .kv:nth-child(3) {order: 2;}
    .kv:nth-child(4) {order: 4;}
    .kv:nth-child(6) {order: 5;}
  } 
}
</style>
